/** @file English catalog part of area E2 (W3-03); replaced whole by that area. */

/** The `hierarchy`, `assets` and `inspector` panel blocks (spread into `panels`). S0 composes it into `en`. */
export const docPanelsEn = {
  hierarchy: {
    title: 'Hierarchy', tree: 'Bones and slots', menu: 'Hierarchy actions', rename: 'Rename', newBone: 'New child bone',
    newSlot: 'New slot', remove: 'Delete…', show: 'Show this attachment', removeEntry: 'Remove from skin',
  },
  assets: {
    title: 'Assets', tree: 'Images and attachments', menu: 'Asset actions', createRegion: 'Create region',
    showInSlot: 'Show in the selected slot', rename: 'Rename', remove: 'Delete…',
  },
  inspector: {
    title: 'Inspector', name: 'Name', parent: 'Parent', delete: 'Delete…', length: 'Length', inherit: 'Inherit',
    chooseAnimation: 'Pick an animation in the timeline to key values.', generated: 'Generated by a socket: edit the socket instead.',
    keyHere: 'Key on this frame', keyOther: 'Keyed on other frames', keysCount: '{n} keys selected', verticesCount: '{n} vertices selected',
    kinds: {
      project: 'Project', bone: 'Bone', slot: 'Slot', region: 'Region attachment', mesh: 'Mesh attachment', image: 'Image',
      skin: 'Skin', ik: 'IK constraint', event: 'Event', socket: 'Socket', animation: 'Animation', reference: 'Reference',
    },
    channels: { x: 'X', y: 'Y', rotation: 'Rotation', scaleX: 'Scale X', scaleY: 'Scale Y', shearX: 'Shear X', shearY: 'Shear Y' },
    key: { frame: 'Frame', value: 'Value', curve: 'Curve', remove: 'Delete keys', inTimeline: 'Edit this key’s value in the timeline.' },
    curve: { mixed: 'Mixed', custom: 'Custom ease', bezier: 'Bezier' },
    mesh: {
      stats: '{vertices} vertices, {triangles} triangles, hull {hull}', rigid: 'Rigid: follows bone {bone}', skinned: 'Skinned to {n} bones',
      weightsHint: 'Edit weights in the Weights panel.',
    },
  },
} as const;
